import { Controller } from "stimulus";

export default class extends Controller {
  submit() {
    this.element.requestSubmit();
  }

  submitIfValid() {
    if (this.element.checkValidity()) this.element.requestSubmit();
  }
}
